/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */
import {useNotification} from "../contexts/NotificationContext";
import React, {useEffect, useState} from "react";
import {FileUploader} from "react-drag-drop-files";
import {Button, CircularProgress, Paper} from "@mui/material";
import Cookies from "js-cookie";
import {useHistory} from "react-router-dom/cjs/react-router-dom";
import {MAIN_ERROR_MESSAGES} from "../constants/errorMessages";
import { getBackendBaseUrl } from "../utils/envUtils";

function Wep() {
  const {setIsOpen, setMessage, setIsFailed} = useNotification();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [processed, setProcessed] = useState(null);
  const [duplicates, setDuplicates] = useState(null);
  const [valid, setValid] = useState(null);
  const [validation, setValidation] = useState(true);
  const token = Cookies.get("crew_token");
  const ohip = Cookies.get('jwtToken');
  const history = useHistory();
  useEffect(() => {
    if (!ohip || !token) {
      history.push("/");
      setIsOpen(true);
      setIsFailed(true);
      setMessage(MAIN_ERROR_MESSAGES.tokenExpired);
    }
  }, []);
  const handleChange = (file) => {
    setFile(file);
  };

  const commit = async () => {
    setLoading(true);
    const host = getBackendBaseUrl();
    try {
      const response = await fetch(
        `${host}/api/v1/wep/commit`, {
          method: 'POST',
          body: JSON.stringify({
            contacts: valid
          }),
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
      if (!response.ok) {
        throw new Error(`HTTP error status: ${response.status}`);
      }
      const result = await response.json();
      setLoading(false);
      setIsFailed(false);
      setMessage(`${result.added} valid emails commited into guestbook`, {color: 'green'});
      setIsOpen(true);
      setValidation(false);
    } catch (error) {
      setLoading(false);
      setIsFailed(true);
      setMessage(`Failed to commit emails: ${error}`);
      setIsOpen(true);
    }
  };

  const handleValidate = async () => {
    const host = getBackendBaseUrl();
    setProcessed(null);
    setDuplicates(null);
    setValid(null);
    setValidation(true);
    setLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await fetch(
        `${host}/api/v1/wep/validate-csv`, {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      if (!response.ok) {
        throw new Error(`HTTP error status: ${response.status}`);
      }
      const result = await response.json();
      setProcessed(result.processed);
      setDuplicates(result.duplicates);
      setValid(result.valid);
      setLoading(false);
      setIsFailed(false);
      setMessage(`${file.name} was validated`, {color: 'green'});
      setIsOpen(true);
      setValidation(false);
    } catch (error) {
      setLoading(false);
      setIsFailed(true);
      setMessage(`Failed to run validation: ${error}`);
      setIsOpen(true);
    }
  };

  return <>
    <Paper
      style={{
        padding: "20px",
        fontFamily: "Monaco, sans-serif",
        fontSize: "14px",
        flexDirection: "column",
        justifyContent: "flex-start",
        marginBottom: "40px"
      }}
    >
      <h2>Wifi Email Processing</h2>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        marginTop: "-170px",
        gap: '20px'
      }}>
        {file && (
          <p>Selected file: {file.name}</p>
        )}
        <FileUploader
          handleChange={handleChange}
          name="file"
          label="Upload the file with emails"
          types={["CSV"]}
          multiple={false}
        />
        {loading ? (
          <CircularProgress sx={{display: "block", m: "0 auto", mt: 5}}/>
        ) : null
        }
        {processed ? <p>Processed records: {processed}</p> : ''}
        {duplicates ? <p>Duplicates: {duplicates}</p> : ''}
        {valid ? <p>Valid records: {valid.length}</p> : ''}
        <Button
          onClick={handleValidate}
          disabled={!file}
        >
          Validate
        </Button>
        <Button
          onClick={commit}
          disabled={validation}
        >
          Commit
        </Button>
      </div>
      {/*<Modal*/}
      {/*  className="modal-populate-reservations"*/}
      {/*  show={modal}*/}
      {/*  onHide={handleCancel}*/}
      {/*  renderBackdrop={renderBackdrop}*/}
      {/*>*/}
      {/*  <div>*/}
      {/*    <div className="modal-header">*/}
      {/*      <div className="modal-title">Validation report for {file ? file.name : ''}:</div>*/}
      {/*      <div>*/}
      {/*        <Button onClick={handleCancel}>X</Button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <p>Records processed: {processed}</p>*/}
      {/*    <p>Records duplicates: {duplicates}</p>*/}
      {/*    <p>Valid records: {valid}</p>*/}
      {/*    <div className="modal-footer">*/}
      {/*      <button className="secondary-button" onClick={handleCancel}>*/}
      {/*        Cancel*/}
      {/*      </button>*/}
      {/*      <Button*/}
      {/*        type="submit"*/}
      {/*        variant={"contained"}*/}
      {/*        sx={{*/}
      {/*          textTransform: "none",*/}
      {/*        }}*/}
      {/*        color="primary"*/}
      {/*      >*/}
      {/*        Commit*/}
      {/*      </Button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</Modal>*/}
    </Paper>
  </>
}

export default Wep;
